import React, { useState } from "react";
import { Modal, Descriptions, Tag, Space, Typography } from "antd";
import { getSubscription } from "../../constants/API/API";
import moment from "moment";
import { CalendarOutlined, ClockCircleOutlined, IdcardOutlined, DollarOutlined, } from "@ant-design/icons";
import useApi from "../../hooks/useApi";

const { Title } = Typography;

const SubscriptionView = ({ visible, setVisible, id }) => {
  const [subscriptionData, setSubscriptionData] = useState(null);

  useApi({
    callback: getSubscription,
    payload: id._id,
    dependencies: [id],
    shouldCallApi: Boolean(id),
    onSuccess: (data) => {
      setSubscriptionData(data);
    },
  });

  const handleCancel = () => {
    setVisible(false);
    setSubscriptionData(null);
  };

  const formatDate = (date) =>
    moment(date).isValid()
      ? moment(date).format("MMMM Do YYYY, h:mm:ss a")
      : "N/A";

  return (
    <Modal
      open={visible}
      className="tab_modal"
      title={
        <Title level={4} style={{ margin: 0 }}>
          Subscription Details
        </Title>
      }
      onCancel={handleCancel}
      footer={null}
      width={800}
      destroyOnClose
    >
      {subscriptionData && (
        <Descriptions
          bordered
          column={1}
          labelStyle={{
            fontWeight: 500,
            backgroundColor: "#fafafa",
            whiteSpace: "nowrap",
            minWidth: "150px",
          }}
          contentStyle={{ backgroundColor: "#fff" }}
        >
          <Descriptions.Item
            label={
              <Space>
                <DollarOutlined /> Plan Name
              </Space>
            }
          >
            {subscriptionData?.name || "N/A"}
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <Space>
                <DollarOutlined /> Plan Price
              </Space>
            }
          >
            {subscriptionData?.price || "N/A"}
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <Space>
                <DollarOutlined /> Description
              </Space>
            }
          >
            {subscriptionData?.description || "N/A"}
          </Descriptions.Item>

          <Descriptions.Item
            label={
              <Space>
                <ClockCircleOutlined /> Status
              </Space>
            }
          >
            <Tag
              color={
                subscriptionData.status === true
                  ? "green"
                  : subscriptionData.status === false
                    ? "red"
                    : "orange"
              }
              style={{
                padding: "4px 12px",
                borderRadius: "12px",
                fontSize: "14px",
              }}
            >
              {subscriptionData.isActive ? "Active" : "Inactive"}
            </Tag>
          </Descriptions.Item>

          <Descriptions.Item
            label={
              <Space>
                <CalendarOutlined /> Validity
              </Space>
            }
          >
            {subscriptionData?.validity}
          </Descriptions.Item>

          <Descriptions.Item
            label={
              <Space>
                <CalendarOutlined /> Created At
              </Space>
            }
          >
            {formatDate(subscriptionData.createdAt)}
          </Descriptions.Item>

          <Descriptions.Item
            label={
              <Space>
                <IdcardOutlined /> Subscription ID
              </Space>
            }
          >
            <Tag style={{ fontFamily: "monospace", fontSize: "13px" }}>
              {subscriptionData.uid}
            </Tag>
          </Descriptions.Item>

          {/* <Descriptions.Item
            label={
              <Space>
                <NumberOutlined /> UID
              </Space>
            }
          >
            <Tag style={{ fontFamily: "monospace", fontSize: "13px" }}>
              {subscriptionData.uid}
            </Tag>
          </Descriptions.Item> */}
        </Descriptions>
      )}
    </Modal>
  );
};

export default SubscriptionView;
